"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _styles = require("@material-ui/core/styles");
var _SttCacheManager = _interopRequireDefault(require("../..//SttCacheManager"));
var _menuUsuario = _interopRequireDefault(require("./menuUsuario"));
var _SttHeading = _interopRequireDefault(require("../../SttTypography/SttHeading"));
var _menuModulos = _interopRequireDefault(require("./menuModulos"));
var _navigationBar = _interopRequireDefault(require("./navigationBar"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    cabecalho: {
      height: "calc(".concat(theme.spacing(6), "px + 10px) !important"),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    toolbar: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: '0px',
      padding: '0'
    },
    nomeSistema: {
      color: '#FFF',
      fontSize: '0.8rem',
      fontWeight: '400',
      textAlign: 'center',
      margin: '0 auto'
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center'
    },
    centerSection: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap'
    },
    rightSection: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto'
    }
  };
});
var HeaderMobile = function HeaderMobile(props) {
  var classes = useStyles();
  var config = props.config,
    redirectUrl = props.redirectUrl,
    _props$mostrarMenuApl = props.mostrarMenuAplicativos,
    mostrarMenuAplicativos = _props$mostrarMenuApl === void 0 ? true : _props$mostrarMenuApl,
    modo = props.modo;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: "static",
    className: "".concat(classes.cabecalho)
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: classes.toolbar
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.leftSection
  }, (config === null || config === void 0 ? void 0 : config.url_base_oauth2) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_menuUsuario["default"], props), /*#__PURE__*/_react["default"].createElement(_SttCacheManager["default"], {
    config: config,
    redirectUrl: redirectUrl,
    modo: modo
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.centerSection
  }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    variant: "h4",
    className: classes.nomeSistema
  }, config.instancia_nome)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.rightSection
  }, mostrarMenuAplicativos && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginRight: 10
    }
  }, /*#__PURE__*/_react["default"].createElement(_menuModulos["default"], {
    config: config
  }))))), /*#__PURE__*/_react["default"].createElement(_navigationBar["default"], props));
};
var _default = HeaderMobile;
exports["default"] = _default;